export default __webpack_public_path__ + "static/media/p2023-50.5b4d0227.jpeg";